import React, {FC, useEffect, useState} from "react"

import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {PaymentProvider, Wallet} from "@irati/types"
import {Radio, CustomNodeRenderer} from "@irati/ui/src/FormItem"
import {Body} from "@irati/ui/src/Typography"
import visaLogo from "@irati-web/payments/src/images/visa.svg"
import mastercardLogo from "@irati-web/payments/src/images/mastercard.svg"
import maestroLogo from "@irati-web/payments/src/images/maestro.svg"
import idealLogo from "@irati-web/payments/src/images/ideal.svg"
import paypalLogo from "@irati-web/payments/src/images/logoPaypal.png"
import googlepayLogo from "@irati-web/payments/src/images/googlepay.svg"
import bancontactLogo from "@irati-web/payments/src/images/bancontact.svg"
import {PaymentAvailability, getPaymentOptions} from "@irati/utils/payment/isPaymentAvailable"

import PayByWalletCheckBox from "./PayByWalletCheckBox"
import {CreditCardImage, BoldMessage, HeaderWrapper} from "./styled"

interface Props {
  currency: string
  isCardSelected: boolean
  isWalletSelected: boolean
  onSelectCard: (value: PaymentProvider) => any
  onSelectWallet: (value: boolean) => any
  walletAmountToBeUsed: number
  wallet?: Wallet
}

const PayByCreditCard: FC<Props> = (props: Props) => {
  const {wallet, walletAmountToBeUsed, currency, isWalletSelected, isCardSelected, onSelectWallet} = props
  const availableWalletBalance = wallet?.availableBalanceInCents || 0

  const [paymentOptions, setPaymentOptions] = useState<PaymentAvailability>({mc: true, visa: true})

  useEffect(() => {
    getPaymentOptions(currency).then((options) => {
      setPaymentOptions(options)
    })
  }, [])

  const boldWalletAmount = (
    <BoldMessage>
      <FormattedMessage
        id="platform.wallet.components.payByWallet.useBalance.innerText"
        values={{amount: <FormattedCurrency value={availableWalletBalance} currency={currency} />}}
      />
    </BoldMessage>
  )

  const creditCardOptions = [
    {
      customNode: (
        <Flex margin={1} direction="column">
          <Flex alignItems="center">
            <Body color="ink">
              <FormattedMessage id="platform.wallet.components.payByWallet.payByCreditCard" values={{amount: boldWalletAmount}} />
            </Body>
            {paymentOptions.googlepay && <CreditCardImage src={googlepayLogo} />}
            {paymentOptions.mc && <CreditCardImage src={mastercardLogo} />}
            {paymentOptions.visa && <CreditCardImage src={visaLogo} />}
            {paymentOptions.maestro && <CreditCardImage src={maestroLogo} />}
            {paymentOptions.ideal && <CreditCardImage src={idealLogo} />}
            {paymentOptions.paypal && <CreditCardImage src={paypalLogo} />}
            {paymentOptions.bancontact && <CreditCardImage src={bancontactLogo} />}
          </Flex>
        </Flex>
      ),
      value: PaymentProvider.Adyen,
      whiteSpace: "wrap"
    }
  ]

  return (
    <HeaderWrapper selected={isCardSelected}>
      <Radio
        rowRenderer={CustomNodeRenderer}
        name="paymentMethodCreditCard"
        value={isCardSelected && PaymentProvider.Adyen}
        options={creditCardOptions}
        onChange={() => props.onSelectCard(PaymentProvider.Adyen)}
      />

      <Flex marginLeft={6}>
        <PayByWalletCheckBox
          onChange={() => onSelectWallet(!isWalletSelected)}
          value={isWalletSelected}
          currency={currency}
          availableBalance={availableWalletBalance}
          remainingBalance={availableWalletBalance - walletAmountToBeUsed || 0}
        />
      </Flex>
    </HeaderWrapper>
  )
}

export default PayByCreditCard
